import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { colors, SovosRaisedButton } from 's1-ui';
import TitleBar from 'pages/TitleBar';
import HeroBanner from '../HeroBanner';
import { pageWidth } from '../../../constants';
import LicensePanel from '../LicensePanel';
import LicenseTableCard from '../LicenseTableCard';

const { buttonOrange, neutralWhite } = colors;

const styles = {
  licenseContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 30,
    maxWidth: pageWidth,
    width: 'calc(100% - 48px)',
    margin: 'auto'
  },
  licenseTitle: {
    fontSize: '30px',
    fontWeight: 300,
    paddingBottom: '20px'
  },
  buttonWrapper: {
    display: 'flex',
    float: 'right',
    width: 'auto',
    flex: '0 1 auto',
    alignSelf: 'flex-end'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 30
  },
  titleText: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  extraPadding: {
    padding: '0 50px 0'
  },
  buttonText: {
    fontWeight: 300
  }
};

/* eslint-disable operator-linebreak */
export const UnstyledHomePage = ({
  classes, licensePanelOpen, openPanel, closePanel, licenseTableRefreshKey, refreshLicenseTableKey, history, panelLabel, editId, licensePanelRefreshKey, onEdit, isProducer
}) => (
  <div className="CCP__HomePage__base">
    <TitleBar history={ history } />
    <HeroBanner />
    <div className={ classes.licenseContainer }>
      <div className={ classes.extraPadding }>
        <div className={ classes.title }>
          <div className={ classes.titleText }>
            <span className={ classes.licenseTitle }>Licenses</span>
            {
              isProducer ?
                <span>DtC Shipping is permitted in 45 states. Review the states where you ship and add your license details.</span>
                :
                <span>DtC Shipping is permitted in a subset of states. Review the states where you ship and add your license details.</span>
            }
          </div>
          <div className={ `CCP__HomePage__button ${classes.buttonWrapper}` }>
            <SovosRaisedButton
              color={ neutralWhite }
              backgroundColor={ buttonOrange }
              onClick={ () => openPanel('Add License') }
            >
              <span className={ classes.buttonText }>Add License</span>
            </SovosRaisedButton>
          </div>
        </div>
        <LicenseTableCard
          key={ licenseTableRefreshKey }
          onDelete={ refreshLicenseTableKey }
          onEdit={ onEdit }
        />
      </div>
    </div>
    <LicensePanel
      closePanel={ closePanel }
      licensePanelOpen={ licensePanelOpen }
      onSubmitted={ refreshLicenseTableKey }
      panelLabel={ panelLabel }
      editId={ editId }
      key={ licensePanelRefreshKey }
    />
  </div>
);

UnstyledHomePage.propTypes = {
  classes: PropTypes.object.isRequired,
  openPanel: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
  licensePanelOpen: PropTypes.bool.isRequired,
  licenseTableRefreshKey: PropTypes.string.isRequired,
  refreshLicenseTableKey: PropTypes.func.isRequired,
  licensePanelRefreshKey: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  panelLabel: PropTypes.string,
  editId: PropTypes.string,
  isProducer: PropTypes.bool
};

UnstyledHomePage.defaultProps = {
  editId: undefined,
  panelLabel: undefined,
  isProducer: false
};

export default withStyles(styles)(UnstyledHomePage);
